<style lang="less">
    .shape_sheet {
        position: absolute;
        bottom: 35px;
        left: 0;
        right: 0;
        z-index: 2;
        background-color: #fff;
        user-select: none;
        .sheet_height_control {
            width: 100%;
            height: 10px;
            position: absolute;
            cursor: ns-resize;
        }
        .edit_block {
            width: 100%;
            height: 25px;
            line-height: 20px;
            margin-top: 10px;
            position: relative;
            > span {
                padding: 5px 8px;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
                cursor: default;
            }
            > input {
                width: 400px;
                height: 100%;
                box-sizing: border-box;
                outline: none;
                user-select: text;
                @media screen and (max-width: 1279px) {
                    width: 40%;
                }
            }
            .edit_finish {
                margin: 0 2px;
                &:hover {
                    background-color: #eee;
                }
            }
            .edit_cancel {
                margin: 0 2px;
                color: red;
                &:hover {
                    background-color: #eee;
                }
            }
        }
        .close_sheet {
            position: absolute;
            top: 0;
            right: 10px;
            width: 25px;
            height: 25px;
            font-size: 25px;
            text-align: center;
            line-height: 25px;
            cursor: default;
            &:hover {
                background-color: #eee;
            }
        }
        .shape_data {
            margin: 2px 5px 0;
            position: absolute;
            bottom: 0;
            top: 35px;
            left: 0;
            right: 0;
            border: 1px solid #ccc;
            border-bottom: none;
            box-sizing: border-box;
            background-color: #fafafa;
            overflow: auto;
            padding-bottom: 150px;
            .shape_data_container {
                width: max-content;
                margin: 0 auto;
                .shape_data_sheet {
                    margin-top: 5px;
                    cursor: default;
                    border-collapse: collapse;
                    table-layout: fixed;
                    white-space: nowrap;
                    color: #000;
                    > tr {
                        height: 20px;
                        line-height: 20px;
                        border: 1px solid #ccc;
                        box-sizing: border-box;
                        & + tr {
                            border-top: none;
                        }
                        > th {
                            box-sizing: border-box;
                            background-color: #cfebf6;
                            color: #333;
                            font-weight: normal;
                            overflow: hidden;
                            & + th {
                                border-left: 1px solid #ccc;
                            }
                            & + td {
                                border-left: 1px solid #ccc;
                            }
                            & > div {
                                opacity: 0;
                                width: 10px;
                                height: 20px;
                                float: right;
                                margin-right: -2px;
                                cursor: ew-resize;
                            }
                        }
                        > td {
                            box-sizing: border-box;
                            padding: 0 5px;
                            overflow: hidden;
                            & + td {
                                border-left: 1px solid #ccc;
                            }
                            &.column_name {
                                text-align: right;
                                color: #c00000;
                                background-color: #f5f5f5;
                            }
                            &.edit_column_name {
                                text-align: right;
                                color: #c00000;
                                background-color: #f5f5f5;
                                cursor: text;
                            }
                            & > div {
                                opacity: 0;
                                width: 10px;
                                height: 20px;
                                float: right;
                                margin-right: -10px;
                                cursor: ew-resize;
                            }
                        }
                        .isedit {
                            outline: 3px solid #333;
                        }
                        .sheet_title {
                            padding: 0 2px;
                            color: #fafafa;
                            background-color: #55789c;
                            text-align: left;
                        }
                        .column_formula {
                            text-align: left;
                            cursor: text;
                        }
                    }
                    .column_control {
                        height: 0;
                        border-top: none;
                        > *::after {
                            content: "";
                            height: 0;
                            display: none;
                        }
                    }
                }
            }
        }
        .context_menu {
            position: absolute;
            min-width: 100px;
            color: #333;
            border: 1px solid #ccc;
            background-color: #fff;
            outline: none;
            .context_menu_type {
                padding: 3px 0;
                > div {
                    position: relative;
                    padding-left: 20px;
                    padding-right: 10px;
                    line-height: 24px;
                }
                > div:hover {
                    background-color: #f0f0f0;
                }
                > .select:before {
                    content: "✓";
                    position: absolute;
                    left: 5px;
                }
                > .disable {
                    color: #ccc;
                }
                & + .context_menu_type {
                    border-top: 1px solid #d2d2d2;
                }
            }
        }
    }
</style>

<template>
    <div class="shape_sheet" v-if="showDataSheet" ref="dataSheet">
        <div class="sheet_height_control" @mousedown="sheetHeightControl($event)"></div>
        <div class="edit_block">
            <span>f</span>
            <input
                type="text"
                v-model="target_value"
                ref="editText"
                spellcheck="false"
                @focus="dataSheetFocus = true"
                @blur="dataSheetFocus = false"
                @keydown="inputKeydown"
            />
            <span class="edit_finish" @click="editTarget()">✓</span>
            <span class="edit_cancel" @click="cancelEdit()">×</span>
            <div class="close_sheet" @click="showDataSheet = false">×</div>
        </div>
        <div class="shape_data" @mousedown="getTarget($event)" @mouseup="rightClick($event)">
            <div class="shape_data_container" ref="sheet_container" v-if="isActived">
                <table class="shape_data_sheet" v-if="Connectors && Connectors.length" style="width: 560px">
                    <tr class="column_control">
                        <th v-for="i in 4" :key="i" :style="{ width: i % 2 ? '120px' : '160px' }"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="4">
                            <div @mousedown="widthControl($event, 3)" @click="stopPropagation"></div>
                            Connectors
                        </th>
                    </tr>
                    <tr class="sheet_row" v-for="i in Math.ceil(Connectors_key.length / 2)" :key="i">
                        <template v-for="index in 2" v-if="Connectors_key[(i - 1) * 2 + index - 1]">
                            <td class="column_name" :key="Connectors_key[(i - 1) * 2 + index - 1]">
                                <div @mousedown="widthControl($event, (index - 1) * 2)" @click="stopPropagation"></div>
                                {{ returnValue(Connectors_key[(i - 1) * 2 + index - 1]) }}
                            </td>
                            <td
                                class="column_formula"
                                :key="index"
                                @mousedown="
                                    getTarget(
                                        $event,
                                        Block_Type.Connectors,
                                        [Connectors_key[(i - 1) * 2 + index - 1]],
                                        Connectors[(i - 1) * 2 + index - 1]
                                    )
                                "
                            >
                                <div @mousedown="widthControl($event, (index - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(Connectors[(i - 1) * 2 + index - 1]) }}
                            </td>
                        </template>
                        <td :colspan="4 - (index - 1) * 2" v-else></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Shape_Transform && Shape_Transform.length" style="width: 840px">
                    <tr class="column_control">
                        <th v-for="i in 6" :key="i" :style="{ width: i % 2 ? '120px' : '160px' }"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="6">
                            <div @mousedown="widthControl($event, 5)" @click="stopPropagation"></div>
                            Shape Transform {{ nameU ? "(" + nameU + ")(" + name + ")" : "" }}
                        </th>
                    </tr>
                    <tr class="sheet_row" v-for="i in Math.ceil(Shape_Transform_key.length / 3)" :key="i">
                        <template v-for="index in 3" v-if="Shape_Transform_key[(i - 1) * 3 + index - 1]">
                            <td class="column_name" :key="Shape_Transform_key[(i - 1) * 3 + index - 1]">
                                <div @mousedown="widthControl($event, (index - 1) * 2)" @click="stopPropagation"></div>
                                {{ returnValue(Shape_Transform_key[(i - 1) * 3 + index - 1]) }}
                            </td>
                            <td
                                class="column_formula"
                                :key="index"
                                @mousedown="
                                    getTarget(
                                        $event,
                                        Block_Type.Shape_Transform,
                                        [Shape_Transform_key[(i - 1) * 3 + index - 1]],
                                        Shape_Transform[(i - 1) * 3 + index - 1]
                                    )
                                "
                            >
                                <div @mousedown="widthControl($event, (index - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(Shape_Transform[(i - 1) * 3 + index - 1]) }}
                            </td>
                        </template>
                        <td :colspan="6 - (index - 1) * 2" v-else></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Connection_Points && Connection_Points.length" style="width: 680px">
                    <tr class="column_control">
                        <th style="width: 140px"></th>
                        <th style="width: 200px"></th>
                        <th style="width: 200px"></th>
                        <th style="width: 140px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Connection Points
                        </th>
                        <th v-for="(text, i) in Connection_Points_key" :key="text">
                            <div @mousedown="widthControl($event, i + 1)" @click="stopPropagation"></div>
                            {{ text }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in Connection_Points" :key="index">
                        <td
                            class="edit_column_name"
                            @mousedown="getTarget($event, Block_Type.Connection_Points, [returnValue(item[0]), 'name'], item[0])"
                        >
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            CPoints.{{ returnValue(item[0]) }}
                        </td>
                        <td
                            class="column_formula"
                            v-for="i in item.length - 1"
                            @mousedown="getTarget($event, Block_Type.Connection_Points, [returnValue(item[0]), i - 1], item[i])"
                            :key="i"
                        >
                            <div @mousedown="widthControl($event, i)" @click="stopPropagation"></div>
                            {{ returnValue(item[i]) }}
                        </td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Variants && Variants.length" style="width: 1140px">
                    <tr class="column_control">
                        <th style="width: 140px"></th>
                        <th style="width: 600px"></th>
                        <th style="width: 400px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Variants
                        </th>
                        <th v-for="(text, i) in Variants_key" :key="text">
                            <div @mousedown="widthControl($event, i + 1)" @click="stopPropagation"></div>
                            {{ text }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in Variants" :key="index">
                        <td class="edit_column_name" @mousedown="getTarget($event, Block_Type.Variants, [returnValue(item[0]), 'name'], item[0])">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Var.{{ returnValue(item[0]) }}
                        </td>
                        <td
                            class="column_formula"
                            v-for="i in item.length - 1"
                            @mousedown="getTarget($event, Block_Type.Variants, [returnValue(item[0]), i - 1], item[i])"
                            :key="i"
                        >
                            <div @mousedown="widthControl($event, i)" @click="stopPropagation"></div>
                            {{ returnValue(item[i]) }}
                        </td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Custom_Properties && Custom_Properties.length" style="width: 1070px">
                    <tr class="column_control">
                        <th style="width: 140px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 100px"></th>
                        <th style="width: 200px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 130px"></th>
                        <th style="width: 100px"></th>
                        <th style="width: 200px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Custom Properties
                        </th>
                        <th v-for="(text, i) in Custom_Properties_key" :key="text">
                            <div @mousedown="widthControl($event, i + 1)" @click="stopPropagation"></div>
                            {{ text }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in Custom_Properties" :key="index">
                        <td
                            class="edit_column_name"
                            @mousedown="getTarget($event, Block_Type.Custom_Properties, [returnValue(item[0]), 'name'], item[0])"
                        >
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Prop.{{ returnValue(item[0]) }}
                        </td>
                        <td
                            class="column_formula"
                            v-for="i in item.length - 1"
                            @mousedown="getTarget($event, Block_Type.Custom_Properties, [returnValue(item[0]), i - 1], item[i])"
                            :key="i"
                        >
                            <div @mousedown="widthControl($event, i)" @click="stopPropagation"></div>
                            {{ returnValue(item[i]) }}
                        </td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Actions && Actions.length" style="width: 1340px">
                    <tr class="column_control">
                        <th style="width: 140px"></th>
                        <th style="width: 240px"></th>
                        <th style="width: 240px"></th>
                        <th style="width: 180px"></th>
                        <th style="width: 180px"></th>
                        <th style="width: 180px"></th>
                        <th style="width: 180px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Actions
                        </th>
                        <th v-for="(text, i) in Actions_key" :key="text">
                            <div @mousedown="widthControl($event, i + 1)" @click="stopPropagation"></div>
                            {{ text }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in Actions" :key="index">
                        <td class="edit_column_name" @mousedown="getTarget($event, Block_Type.Actions, [returnValue(item[0]), 'name'], item[0])">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Actions.{{ returnValue(item[0]) }}
                        </td>
                        <td
                            class="column_formula"
                            v-for="i in item.length - 1"
                            @mousedown="getTarget($event, Block_Type.Actions, [returnValue(item[0]), i - 1], item[i])"
                            :key="i"
                        >
                            <div @mousedown="widthControl($event, i)" @click="stopPropagation"></div>
                            {{ returnValue(item[i]) }}
                        </td>
                        <td v-if="index == 0" :rowspan="Actions_key.length"></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Controls && Controls.length" style="width: 1570px">
                    <tr class="column_control">
                        <th style="width: 140px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 150px"></th>
                        <th style="width: 80px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Controls
                        </th>
                        <th v-for="(text, i) in Controls_key" :key="text">
                            <div @mousedown="widthControl($event, i + 1)" @click="stopPropagation"></div>
                            {{ text }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in Controls" :key="index">
                        <td class="edit_column_name" @mousedown="getTarget($event, Block_Type.Controls, [returnValue(item[0]), 'name'], item[0])">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Controls.{{ returnValue(item[0]) }}
                        </td>
                        <td
                            class="column_formula"
                            v-for="i in item.length - 1"
                            @mousedown="getTarget($event, Block_Type.Controls, [returnValue(item[0]), i - 1], item[i])"
                            :key="i"
                        >
                            <div @mousedown="widthControl($event, i)" @click="stopPropagation"></div>
                            {{ returnValue(item[i]) }}
                        </td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Numbers && Numbers.length" style="width: 1020px">
                    <tr class="column_control">
                        <th style="width: 140px"></th>
                        <th style="width: 220px"></th>
                        <th style="width: 220px"></th>
                        <th style="width: 220px"></th>
                        <th style="width: 220px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            Numbers
                        </th>
                        <th v-for="(text, i) in Numbers_key" :key="text">
                            <div @mousedown="widthControl($event, i + 1)" @click="stopPropagation"></div>
                            {{ text }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in Numbers" :key="index">
                        <th>
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            {{ "Numbers" + (index + 1) }}
                        </th>
                        <td
                            class="column_formula"
                            v-for="i in item.length"
                            @mousedown="getTarget($event, Block_Type.Numbers, [index + 1, i - 1], item[i - 1])"
                            :key="i"
                        >
                            <div @mousedown="widthControl($event, i)" @click="stopPropagation"></div>
                            {{ returnValue(item[i - 1]) }}
                        </td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-for="(geo, index) in Geometry" :key="'geo' + index" style="width: 1440px">
                    <tr class="column_control">
                        <th style="width: 140px"></th>
                        <th style="width: 180px"></th>
                        <th style="width: 160px"></th>
                        <th style="width: 160px"></th>
                        <th style="width: 160px"></th>
                        <th style="width: 160px"></th>
                        <th style="width: 160px"></th>
                        <th style="width: 160px"></th>
                        <th style="width: 160px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="9">
                            <div @mousedown="widthControl($event, 8)" @click="stopPropagation"></div>
                            Geometry{{ index + 1 }}
                        </th>
                    </tr>
                    <tr>
                        <template v-for="i in 5" v-if="Geometry_key[i - 1]">
                            <td class="column_name" :key="Geometry_key[i - 1]">
                                <div @mousedown="widthControl($event, (i - 1) * 2)" @click="stopPropagation"></div>
                                {{ Geometry_key[i - 1] }}
                            </td>
                            <td
                                class="column_formula"
                                :key="i"
                                @mousedown="getTarget($event, Block_Type.Geometry, [index, Geometry_key[i - 1]], geo[Geometry_key[i - 1]])"
                            >
                                <div @mousedown="widthControl($event, (i - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(geo[Geometry_key[i - 1]]) }}
                            </td>
                        </template>
                        <td :colspan="9 - (i - 1) * 2" v-else></td>
                    </tr>
                    <tr>
                        <th v-for="(text, i) in ['Name', 'X', 'Y', 'A', 'B', 'C', 'D', 'E', 'F']" :key="text">
                            <div @mousedown="widthControl($event, i)" @click="stopPropagation"></div>
                            {{ text }}
                        </th>
                    </tr>
                    <tr v-for="(item, idx) in geo.Point" :key="idx">
                        <td class="column_name">
                            <div @mousedown="widthControl($event, 0)" @click="stopPropagation"></div>
                            {{ geo.Type[idx] }}
                        </td>
                        <td
                            class="column_formula"
                            v-for="(num, i) in item"
                            @mousedown="getTarget($event, Block_Type.Geometry, [index, idx, i], item[i])"
                            :key="i"
                        >
                            <div @mousedown="widthControl($event, i + 1)" @click="stopPropagation"></div>
                            {{ returnValue(item[i]) }}
                        </td>
                        <td :colspan="9 - item.length - 1" v-if="9 - item.length > 1"></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Protection && Protection.length" style="width: 840px">
                    <tr class="column_control">
                        <th v-for="i in 6" :key="i" :style="{ width: i % 2 ? '120px' : '160px' }"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="6">
                            <div @mousedown="widthControl($event, 5)" @click="stopPropagation"></div>
                            Protection
                        </th>
                    </tr>
                    <tr class="sheet_row" v-for="i in Math.ceil(Protection_key.length / 3)" :key="i">
                        <template v-for="index in 3" v-if="Protection_key[(i - 1) * 3 + index - 1]">
                            <td class="column_name" :key="Protection_key[(i - 1) * 3 + index - 1]">
                                <div @mousedown="widthControl($event, (index - 1) * 2)" @click="stopPropagation"></div>
                                {{ Protection_key[(i - 1) * 3 + index - 1] }}
                            </td>
                            <td
                                class="column_formula"
                                :key="index"
                                @mousedown="
                                    getTarget(
                                        $event,
                                        Block_Type.Protection,
                                        [Protection_key[(i - 1) * 3 + index - 1]],
                                        Protection[(i - 1) * 3 + index - 1]
                                    )
                                "
                            >
                                <div @mousedown="widthControl($event, (index - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(Protection[(i - 1) * 3 + index - 1]) }}
                            </td>
                        </template>
                        <td :colspan="6 - (index - 1) * 2" v-else></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Misc && Misc.length" style="width: 840px">
                    <tr class="column_control">
                        <th v-for="i in 6" :key="i" :style="{ width: '140px' }"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="6">
                            <div @mousedown="widthControl($event, 5)" @click="stopPropagation"></div>
                            Misc
                        </th>
                    </tr>
                    <tr class="sheet_row" v-for="i in Math.ceil(Misc_key.length / 3)" :key="i">
                        <template v-for="index in 3" v-if="Misc_key[(i - 1) * 3 + index - 1]">
                            <td class="column_name" :key="Misc_key[(i - 1) * 3 + index - 1]">
                                <div @mousedown="widthControl($event, (index - 1) * 2)" @click="stopPropagation"></div>
                                {{ Misc_key[(i - 1) * 3 + index - 1] }}
                            </td>
                            <td
                                class="column_formula"
                                :key="index"
                                @mousedown="getTarget($event, Block_Type.Misc, [Misc_key[(i - 1) * 3 + index - 1]], Misc[(i - 1) * 3 + index - 1])"
                            >
                                <div @mousedown="widthControl($event, (index - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(Misc[(i - 1) * 3 + index - 1]) }}
                            </td>
                        </template>
                        <td :colspan="6 - (index - 1) * 2" v-else></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Group_Properties && Group_Properties.length" style="width: 840px">
                    <tr class="column_control">
                        <th v-for="i in 6" :key="i" :style="{ width: '140px' }"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="6">
                            <div @mousedown="widthControl($event, 5)" @click="stopPropagation"></div>
                            Group Properties
                        </th>
                    </tr>
                    <tr class="sheet_row" v-for="i in Math.ceil(Group_Properties_key.length / 3)" :key="i">
                        <template v-for="index in 3" v-if="Group_Properties_key[(i - 1) * 3 + index - 1]">
                            <td class="column_name" :key="Group_Properties_key[(i - 1) * 3 + index - 1]">
                                <div @mousedown="widthControl($event, (index - 1) * 2)" @click="stopPropagation"></div>
                                {{ Group_Properties_key[(i - 1) * 3 + index - 1] }}
                            </td>
                            <td
                                class="column_formula"
                                :key="index"
                                @mousedown="
                                    getTarget(
                                        $event,
                                        Block_Type.Group_Properties,
                                        [Group_Properties_key[(i - 1) * 3 + index - 1]],
                                        Group_Properties[(i - 1) * 3 + index - 1]
                                    )
                                "
                            >
                                <div @mousedown="widthControl($event, (index - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(Group_Properties[(i - 1) * 3 + index - 1]) }}
                            </td>
                        </template>
                        <td :colspan="6 - (index - 1) * 2" v-else></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-if="Events && Events.length" style="width: 840px">
                    <tr class="column_control">
                        <th v-for="i in 6" :key="i" :style="{ width: i % 2 ? '120px' : '160px' }"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="6">
                            <div @mousedown="widthControl($event, 5)" @click="stopPropagation"></div>
                            Event
                        </th>
                    </tr>
                    <tr class="sheet_row" v-for="i in Math.ceil(Events_key.length / 3)" :key="i">
                        <template v-for="index in 3" v-if="Events_key[(i - 1) * 3 + index - 1]">
                            <td class="column_name" :key="Events_key[(i - 1) * 3 + index - 1]">
                                <div @mousedown="widthControl($event, (index - 1) * 2)" @click="stopPropagation"></div>
                                {{ Events_key[(i - 1) * 3 + index - 1] }}
                            </td>
                            <td
                                class="column_formula"
                                :key="index"
                                @mousedown="
                                    getTarget($event, Block_Type.Events, [Events_key[(i - 1) * 3 + index - 1]], Events[(i - 1) * 3 + index - 1])
                                "
                            >
                                <div @mousedown="widthControl($event, (index - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(Events[(i - 1) * 3 + index - 1]) }}
                            </td>
                        </template>
                        <td :colspan="6 - (index - 1) * 2" v-else></td>
                    </tr>
                </table>

                <table class="shape_data_sheet" v-for="(text, index) in Text_Blocks" :key="'text' + index" style="width: 920px">
                    <tr class="column_control">
                        <th style="width: 120px"></th>
                        <th style="width: 240px"></th>
                        <th style="width: 120px"></th>
                        <th style="width: 160px"></th>
                        <th style="width: 120px"></th>
                        <th style="width: 160px"></th>
                    </tr>
                    <tr>
                        <th class="sheet_title" colspan="6">
                            <div @mousedown="widthControl($event, 5)" @click="stopPropagation"></div>
                            Text Blocks
                        </th>
                    </tr>
                    <tr>
                        <td class="edit_column_name" colspan="2" @mousedown="getTarget($event, Block_Type.Text_Blocks, [index, 'name'], text[0])">
                            <div @mousedown="widthControl($event, 1)" @click="stopPropagation"></div>
                            Text.{{ returnValue(text[0]) }}
                        </td>
                        <td class="column_name">
                            <div @mousedown="widthControl($event, 2)" @click="stopPropagation"></div>
                            ID
                        </td>
                        <td class="column_name">
                            <div @mousedown="widthControl($event, 3)" @click="stopPropagation"></div>
                            {{ returnValue(text[1]) }}
                        </td>
                        <td class="column_name" colspan="2">
                            <div @mousedown="widthControl($event, 5)" @click="stopPropagation"></div>
                        </td>
                    </tr>
                    <tr class="sheet_row" v-for="i in Math.ceil(Text_Blocks_key.length / 3)" :key="i">
                        <template v-for="idx in 3" v-if="Text_Blocks_key[(i - 1) * 3 + idx - 1]">
                            <td class="column_name" :key="Text_Blocks_key[(i - 1) * 3 + idx - 1]">
                                <div @mousedown="widthControl($event, (idx - 1) * 2)" @click="stopPropagation"></div>
                                {{ Text_Blocks_key[(i - 1) * 3 + idx - 1] }}
                            </td>
                            <td
                                class="column_formula"
                                :key="idx"
                                @mousedown="
                                    getTarget(
                                        $event,
                                        Block_Type.Text_Blocks,
                                        [index, Text_Blocks_key[(i - 1) * 3 + idx - 1]],
                                        text[(i - 1) * 3 + idx + 1]
                                    )
                                "
                            >
                                <div @mousedown="widthControl($event, (idx - 1) * 2 + 1)" @click="stopPropagation"></div>
                                {{ returnValue(text[(i - 1) * 3 + idx + 1]) }}
                            </td>
                        </template>
                        <td :colspan="6 - (idx - 1) * 2" v-else></td>
                    </tr>
                </table>
            </div>
        </div>
        <div
            class="context_menu"
            v-show="isShowMenu"
            tabindex="-1"
            @blur="showMenus(false)"
            :style="{ left: menuPosition.x + 'px', top: menuPosition.y + 'px' }"
            ref="sheetMenu"
        >
            <div class="context_menu_type">
                <div :class="{ select: !isFormula }" @click.stop="showFormula(false)">{{ $t("menu.value") }}</div>
                <div :class="{ select: isFormula }" @click.stop="showFormula(true)">{{ $t("menu.formula") }}</div>
            </div>
            <div class="context_menu_type">
                <div :class="{ disable: !isActived }" @click.stop="insertBlock">{{ $t("menu.insertBlock") }}</div>
                <div :class="{ disable: !canDeleteBlock() }" @click.stop="deleteBlocks">{{ $t("menu.deleteBlock") }}</div>
            </div>
            <div class="context_menu_type">
                <div :class="{ disable: canOpreateRow() == null }" @click.stop="insertRow">{{ $t("menu.insertRow") }}</div>
                <div :class="{ disable: canOpreateRow() == null }" @click.stop="deleteRow">{{ $t("menu.deleteRow") }}</div>
                <div :class="{ disable: target_block != Block_Type.Geometry || isNaN(parseInt(target[1])) }" @click.stop="modifyBlock">
                    {{ $t("menu.modifyType") }}
                </div>
                <div :class="{ disable: isBorder() }" @click.stop="rowMoveUps">{{ $t("menu.moveUp") }}</div>
                <div :class="{ disable: isBorder(false) }" @click.stop="rowMoveDowns">{{ $t("menu.moveDown") }}</div>
            </div>
            <div class="context_menu_type">
                <div :class="{ disable: !isActived }" @click.stop="lineOrBox2">{{ $t("menu.lineOrBox") }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    declare var ExpErrorCode: any;
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class DataSheet extends Vue {
        // 右键菜单栏
        isFormula: boolean = true;
        isShowMenu: boolean = false;
        menuPosition: { x: number; y: number } = { x: 0, y: 0 };

        // 选中的条目
        target: Array<string> = []; //对象路径
        target_value: string = "";
        target_value_copy: string = "";
        target_block: number = -1; //记录点击位置属于哪个块
        active_column: HTMLElement;

        //对应返回的值
        returnValue(obj, flag?) {
            //flag强制已公式优先
            if (flag == null) flag = this.isFormula;
            if (flag && obj.formula) {
                return obj.formula;
            } else if (typeof obj == "string") return obj;
            else return obj.value;
        }

        //右键菜单相关
        rightClick(event) {
            if (event.button == 2) {
                this.showMenus(true);
                this.menuPosition.x = -200;
                this.menuPosition.y = -200;
                let dataSheet = this.$refs.dataSheet as HTMLElement;
                let x = event.clientX - dataSheet.offsetLeft,
                    y = event.clientY - dataSheet.offsetTop;
                setTimeout(() => {
                    this.menuPosition.x = x;
                    this.menuPosition.y = y;
                    let ele = this.$refs.sheetMenu as HTMLElement;
                    if (window.innerWidth - event.clientX < ele.offsetWidth) this.menuPosition.x -= ele.clientWidth;
                    if (window.innerHeight - event.clientY < ele.offsetHeight) this.menuPosition.y -= ele.clientHeight - 2;
                }, 0);
            } else {
                this.showMenus(false);
            }
        }
        showMenus(flag: boolean) {
            this.isShowMenu = !!flag;
            if (!!flag) {
                setTimeout(() => {
                    let ele = this.$refs.sheetMenu as HTMLElement;
                    ele.focus();
                }, 0);
            }
        }
        showFormula(flag: boolean) {
            this.isFormula = !!flag;
            this.showMenus(false);
        }
        canDeleteBlock() {
            //选中的块是否能删除
            switch (this.target_block) {
                case this.Block_Type.Connection_Points:
                case this.Block_Type.Variants:
                case this.Block_Type.Custom_Properties:
                case this.Block_Type.Actions:
                case this.Block_Type.Controls:
                case this.Block_Type.Numbers:
                case this.Block_Type.Geometry:
                case this.Block_Type.Text_Blocks: {
                    return true;
                }
            }
        }
        deleteBlocks() {
            //删除块
            if (!this.isActived) return;
            if (!this.canDeleteBlock()) return;
            let index = 0,
                flag = 0;
            switch (this.target_block) {
                case this.Block_Type.Connection_Points:
                case this.Block_Type.Variants:
                case this.Block_Type.Custom_Properties:
                case this.Block_Type.Actions:
                case this.Block_Type.Controls:
                case this.Block_Type.Numbers: {
                    flag = this.target_block;
                    break;
                }
                case this.Block_Type.Text_Blocks: {
                    flag = this.target_block;
                    index = parseInt(this.target[0]);
                    if (index < 0) return;
                    break;
                }
                case this.Block_Type.Geometry: {
                    flag = this.target_block;
                    index = parseInt(this.target[0]);
                    if (index < 0) return;
                    break;
                }
            }
            let sign = window["_view"].deleteBlock(flag, index);
            if (sign == ExpErrorCode.OK) {
                this.showMenus(false);
                this.reloadItem();
            }
        }
        //可操作会返回所在行数
        canOpreateRow() {
            if (!this.isActived) return;
            let index: number = null;
            let name = this.target[0];
            switch (this.target_block) {
                case this.Block_Type.Connection_Points: {
                    for (let i = 0; i < this.Connection_Points.length; ++i) {
                        let obj = this.Connection_Points[i];
                        if (obj[0].value == name) {
                            index = i;
                            break;
                        }
                    }
                    break;
                }
                case this.Block_Type.Variants: {
                    for (let i = 0; i < this.Variants.length; ++i) {
                        let obj = this.Variants[i];
                        if (obj[0].value == name) {
                            index = i;
                            break;
                        }
                    }
                    break;
                }
                case this.Block_Type.Custom_Properties: {
                    for (let i = 0; i < this.Custom_Properties.length; ++i) {
                        let obj = this.Custom_Properties[i];
                        if (obj[0].value == name) {
                            index = i;
                            break;
                        }
                    }
                    break;
                }
                case this.Block_Type.Actions: {
                    for (let i = 0; i < this.Actions.length; ++i) {
                        let obj = this.Actions[i];
                        if (obj[0].value == name) {
                            index = i;
                            break;
                        }
                    }
                    break;
                }
                case this.Block_Type.Controls: {
                    for (let i = 0; i < this.Controls.length; ++i) {
                        let obj = this.Controls[i];
                        if (obj[0].value == name) {
                            index = i;
                            break;
                        }
                    }
                    break;
                }
                case this.Block_Type.Numbers: {
                    index = parseInt(name) - 1;
                    break;
                }
                case this.Block_Type.Geometry: {
                    let seg = parseInt(this.target[0]);
                    if (!isNaN(seg)) index = seg;
                    break;
                }
            }
            return index;
        }
        isBorder(top = true) {
            //是否为最上或最下行
            if (!this.isActived) return true;
            let index = this.canOpreateRow();
            if (index == null) return true;
            switch (this.target_block) {
                case this.Block_Type.Connection_Points: {
                    return true;
                }
                case this.Block_Type.Variants: {
                    if (top && index == 0) return true;
                    else if (!top && index == this.Variants_key.length - 1) return true;
                    break;
                }
                case this.Block_Type.Custom_Properties: {
                    if (top && index == 0) return true;
                    else if (!top && index == this.Custom_Properties_key.length - 1) return true;
                    break;
                }
                case this.Block_Type.Actions: {
                    if (top && index == 0) return true;
                    else if (!top && index == this.Actions_key.length - 1) return true;
                    break;
                }
                case this.Block_Type.Controls: {
                    return true;
                }
                case this.Block_Type.Numbers: {
                    return true;
                }
                case this.Block_Type.Geometry: {
                    if (index >= 0) {
                        index = parseInt(this.target[0]);
                        if (top && index == 0) return true;
                        else if (!top && index == this.Geometry.length - 1) return true;
                    } else return true;
                }
            }
            return false;
        }
        insertRow() {
            if (!this.isActived) return;
            let row = this.canOpreateRow(),
                flag = -1;
            if (row == null) return;
            let index = null;
            switch (this.target_block) {
                case this.Block_Type.Connection_Points:
                case this.Block_Type.Variants:
                case this.Block_Type.Custom_Properties:
                case this.Block_Type.Actions:
                case this.Block_Type.Controls:
                case this.Block_Type.Numbers: {
                    flag = this.target_block;
                    break;
                }
                case this.Block_Type.Geometry: {
                    flag = this.target_block;
                    index = parseInt(this.target[1]);
                    if (isNaN(index)) return;
                    break;
                }
            }
            let sign = window["_view"].insRow(flag, row, index);
            if (sign == ExpErrorCode.OK) {
                this.showMenus(false);
                this.reloadItem();
            }
        }
        deleteRow() {
            if (!this.isActived) return;
            let row = this.canOpreateRow(),
                flag = 0;
            if (row == null) return;
            let index = null;
            switch (this.target_block) {
                case this.Block_Type.Connection_Points:
                case this.Block_Type.Variants:
                case this.Block_Type.Custom_Properties:
                case this.Block_Type.Actions:
                case this.Block_Type.Controls:
                case this.Block_Type.Numbers: {
                    flag = this.target_block;
                    break;
                }
                case this.Block_Type.Geometry: {
                    flag = this.target_block;
                    index = parseInt(this.target[1]);
                    if (isNaN(index)) return;
                }
            }
            let sign = window["_view"].delRow(flag, row, index);
            if (sign == ExpErrorCode.OK) {
                this.showMenus(false);
                this.reloadItem();
            }
        }
        rowMoveUps() {
            if (this.isBorder()) return;
            let view = window["_view"];
            if (view) {
                let row = this.canOpreateRow();
                let flag = this.target_block;
                view.rowMoveUp(flag, row);
                this.showMenus(false);
                this.reloadItem();
            }
        }

        rowMoveDowns() {
            if (this.isBorder(false)) return;
            let view = window["_view"];
            if (view) {
                let row = this.canOpreateRow();
                let flag = this.target_block;
                view.rowMoveDown(flag, row);
                this.showMenus(false);
                this.reloadItem();
            }
        }

        lineOrBox2() {
            let view = window["_view"];
            if (view) {
                view.lineOrBox();
                this.showMenus(false);
                this.reloadItem();
            }
        }
        //打开更改类型窗口
        modifyBlock() {
            let segCount = parseInt(this.target[1]);
            if (this.target_block == this.Block_Type.Geometry && !isNaN(segCount)) {
                this.$store.commit("setDialogState", {
                    type: "dialogType",
                    data: "ModifyBlock",
                });
                this.$store.commit("setStatus", {
                    type: "segPosition",
                    data: [parseInt(this.target[0]), segCount],
                });
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: true,
                });
                this.showMenus(false);
            }
        }
        //打开添加块窗口
        insertBlock() {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "InsertBlock",
            });
            this.$store.commit("setStatus", {
                type: "insertBlock",
                data: [
                    this.Actions.length != 0,
                    this.Connection_Points.length != 0,
                    false,
                    this.Controls.length != 0,
                    this.Variants.length != 0,
                    this.Custom_Properties.length != 0,
                    this.Numbers.length != 0,
                    false,
                ],
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.showMenus(false);
        }
        reloadItem() {
            //重新获取数据，用在修改完成后
            window["_view"].getActiveData();
        }
        //修改数据相关
        getTarget(event: MouseEvent, block: number, target: Array<string>, value) {
            //选中修改项
            if (block != null && target != null) {
                this.target_block = block;
                this.target = target;
                this.target_value = this.returnValue(value, true);
            } else {
                this.target_block = -1;
                this.target = [];
                this.target_value = "";
            }
            this.target_value_copy = this.target_value;

            if (this.active_column) {
                this.active_column.classList.remove("isedit");
            }
            if (event) {
                event.stopPropagation();
                this.active_column = event.currentTarget as HTMLElement;
                this.active_column.classList.add("isedit");
                if (this.target_value && event.button == 0) {
                    setTimeout(() => {
                        (this.$refs.editText as HTMLInputElement).focus();
                    }, 0);
                }
            } else {
                this.active_column = null;
            }
            this.updatePoint();
        }
        updatePoint() {
            let x = null,
                y = null;
            if (this.isActived) {
                switch (this.target_block) {
                    case this.Block_Type.Connection_Points: {
                        let name = this.target[0];
                        for (let i = 0; i < this.Connection_Points.length; ++i) {
                            let obj = this.Connection_Points[i];
                            if (obj[0].value == name) {
                                x = obj[1].value;
                                y = obj[2].value;
                                break;
                            }
                        }
                        break;
                    }
                    case this.Block_Type.Controls: {
                        let name = this.target[0];
                        for (let i = 0; i < this.Controls.length; ++i) {
                            let obj = this.Controls[i];
                            if (obj[0].value == name) {
                                x = obj[1].value;
                                y = obj[2].value;
                                break;
                            }
                        }
                        break;
                    }
                    case this.Block_Type.Geometry: {
                        let geoCount = parseInt(this.target[0]);
                        let segCount = parseInt(this.target[1]);
                        if (!isNaN(geoCount) && !isNaN(segCount)) {
                            x = this.Geometry[geoCount].Point[segCount][0].value;
                            y = this.Geometry[geoCount].Point[segCount][1].value;
                        }
                        break;
                    }
                    case this.Block_Type.Text_Blocks: {
                        let textNum = this.target[0];
                        let text = this.Text_Blocks[textNum];
                        if (text.length == 11) {
                            window["_view"].updateDataSheetPt(
                                parseFloat(text[3].value),
                                parseFloat(text[6].value),
                                parseFloat(text[8].value),
                                parseFloat(text[2].value),
                                parseFloat(text[5].value),
                                parseFloat(text[4].value),
                                parseFloat(text[7].value)
                            );
                        }

                        return;
                    }
                }
            }
            window["_view"].updateDataSheetPt(x, y);
        }
        editTarget() {
            //修改数据
            if (this.target.length && this.target_block != -1) {
                let code = window["_view"].setShapeValue(this.target_block, this.target, this.target_value);
                if (code == ExpErrorCode.Error) {
                    alert("error");
                } else if (code == ExpErrorCode.Wrong_Value_Type) {
                    alert("wrong value type");
                } else if (code == ExpErrorCode.Name_Exist) {
                    alert("name is already exist");
                } else {
                    this.reloadItem();
                    if (this.active_column) {
                        setTimeout(() => {
                            // let copy = this.target_value_copy;
                            var event = document.createEvent("MouseEvents");
                            event.initEvent("mousedown", true, false);
                            this.active_column.dispatchEvent(event);
                            // let value = this.target_value.replace(/\"/g, '');
                            // if(value) {
                            //     this.target_value = value;
                            // }
                            // this.target_value_copy = this.target_value;
                        }, 200);
                    }
                }
            } else {
                this.cancelEdit();
            }
        }
        cancelEdit() {
            //恢复至选中时的数据
            if (this.target != null) {
                this.target_value = this.target_value_copy;
            } else {
                this.target_value = "";
            }
        }

        inputKeydown(e: KeyboardEvent) {
            if (e.keyCode == 13) this.editTarget();
        }

        widthControl(e: MouseEvent, i: number) {
            //伸缩表格宽度
            let target = e.target as HTMLElement;
            while (target.nodeName.toLowerCase() != "table") {
                target = target.parentElement;
            }
            let table = target;
            let tw = table.clientWidth;
            let control_list = target.getElementsByClassName("column_control")[0];
            if (i < 0 || i >= control_list.children.length) return;
            target = control_list.children[i] as HTMLElement;
            let width = target.clientWidth;
            window.onmousemove = (ev) => {
                let dx = ev.clientX - e.clientX;
                if (width + dx <= 20) dx = 20 - width;
                target.style.width = width + dx + "px";
                table.style.width = tw + dx + "px";
            };
            window.onmouseup = () => {
                window.onmousemove = null;
                window.onmouseup = null;
            };
        }

        sheetHeightControl(e) {
            //datasheet高度
            let lastH = this.dataSheetHeight;
            document.onmousemove = (ev) => {
                let nowH = lastH + e.pageY - ev.pageY;
                if (nowH < 200) nowH = 200;
                if (nowH > window.innerHeight / 2 - 150) nowH = window.innerHeight / 2 - 150;
                this.dataSheetHeight = nowH;
                window["_view"].onsize();
                window["_view"].scroll();
            };

            document.onmouseup = (ev) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }

        stopPropagation(e) {
            e.stopPropagation();
        }

        get Block_Type() {
            return this.$store.state.datasheet.Block_Type;
        }
        get id() {
            return this.$store.state.shape.id;
        }
        get isActived() {
            return this.$store.state.shape.isActived;
        }
        // 数据
        get name() {
            return this.$store.state.datasheet.name;
        }
        get nameU() {
            return this.$store.state.datasheet.nameU;
        }
        get Connectors() {
            return this.$store.state.datasheet.Connectors;
        }
        get Connectors_key() {
            return this.$store.getters.Connectors_key;
        }
        get Shape_Transform() {
            return this.$store.state.datasheet.Shape_Transform;
        }
        get Shape_Transform_key() {
            return this.$store.getters.Shape_Transform_key;
        }
        get Connection_Points() {
            return this.$store.state.datasheet.Connection_Points;
        }
        get Connection_Points_key() {
            return this.$store.getters.Connection_Points_key;
        }
        get Variants() {
            return this.$store.state.datasheet.Variants;
        }
        get Variants_key() {
            return this.$store.getters.Variants_key;
        }
        get Custom_Properties() {
            return this.$store.state.datasheet.Custom_Properties;
        }
        get Custom_Properties_key() {
            return this.$store.getters.Custom_Properties_key;
        }
        get Actions() {
            return this.$store.state.datasheet.Actions;
        }
        get Actions_key() {
            return this.$store.getters.Actions_key;
        }
        get Controls() {
            return this.$store.state.datasheet.Controls;
        }
        get Controls_key() {
            return this.$store.getters.Controls_key;
        }
        get Numbers() {
            return this.$store.state.datasheet.Numbers;
        }
        get Numbers_key() {
            return this.$store.getters.Numbers_key;
        }
        get Geometry() {
            return this.$store.state.datasheet.Geometry;
        }
        get Geometry_key() {
            return this.$store.getters.Geometry_key;
        }
        get Protection() {
            return this.$store.state.datasheet.Protection;
        }
        get Protection_key() {
            return this.$store.getters.Protection_key;
        }
        get Misc() {
            return this.$store.state.datasheet.Misc;
        }
        get Misc_key() {
            return this.$store.getters.Misc_key;
        }
        get Group_Properties() {
            return this.$store.state.datasheet.Group_Properties;
        }
        get Group_Properties_key() {
            return this.$store.getters.Group_Properties_key;
        }
        get Events() {
            return this.$store.state.datasheet.Events;
        }
        get Events_key() {
            return this.$store.getters.Events_key;
        }
        get Text_Blocks() {
            return this.$store.state.datasheet.Text_Blocks;
        }
        get Text_Blocks_key() {
            return this.$store.getters.Text_Blocks_key;
        }

        get showDataSheet(): boolean {
            return this.$store.state.ui.showDataSheet;
        }

        set showDataSheet(v: boolean) {
            this.$store.state.ui.showDataSheet = v;
            if (!v) this.dataSheetHeight = 0;
        }

        get dataSheetHeight(): number {
            return this.$store.state.ui.dataSheetHeight;
        }

        set dataSheetHeight(v: number) {
            this.$store.commit("setStatus", {
                type: "dataSheetHeight",
                data: v,
            });
            this.$nextTick(() => {
                window["_view"].onsize();
            });
        }
        //datasheet编辑框是否focus
        get dataSheetFocus(): boolean {
            return this.$store.state.ui.dataSheetFocus;
        }

        set dataSheetFocus(v: boolean) {
            this.$store.commit("setStatus", {
                type: "dataSheetFocus",
                data: v,
            });
        }

        @Watch("id")
        onShapeChanged(val: string, oldVal: string) {
            this.getTarget(null, null, null, null);
        }

        //生命周期
        mounted() {
            let view = window["_view"];
            this.$nextTick(() => {
                view && view.onsize();
            });
        }

        created() {}

        beforeDestroy() {
            let view = window["_view"];
            this.$nextTick(() => {
                view && view.onsize();
            });
        }
    }
</script>
<i18n>
{
  "zh": {
    "menu": {
      "value": "值",
      "formula": "公式",
      "insertBlock": "插入块",
      "deleteBlock": "删除块",
      "insertRow": "插入行",
      "deleteRow": "删除行",
      "modifyType": "修改块",
      "moveUp": "上移",
      "moveDown": "下移",
      "lineOrBox": "线或框"
    }
  },
  "fr": {
    "menu": {
      "value": "Valeur",
      "formula": "Formule",
      "insertBlock": "Insérer un bloc",
      "deleteBlock": "Supprimer le bloc",
      "insertRow": "Insérer une ligne",
      "deleteRow": "Supprimer la ligne",
      "modifyType": "Modifier le bloc",
      "moveUp": "Déplacer vers haut",
      "moveDown": "Déplacer vers bas",
      "lineOrBox": "Ligne ou boîte"
    }
  },
  "de": {
    "menu": {
      "value": "Wert",
      "formula": "Formel",
      "insertBlock": "Block einfügen",
      "deleteBlock": "Block löschen",
      "insertRow": "Spalte einfügen",
      "deleteRow": "Spalte löschen",
      "modifyType": "Typ ändern",
      "moveUp": "Nach oben ",
      "moveDown": "Nach unten",
      "lineOrBox": "Linien oder Rahmen"
    }
  },
  "en": {
    "menu": {
      "value": "Value",
      "formula": "Formula",
      "insertBlock": "Insert Block",
      "deleteBlock": "Delete Block",
      "insertRow": "Insert Row",
      "deleteRow": "Delete Row",
      "modifyType": "Modify Type",
      "moveUp": "Move Up",
      "moveDown": "Move Down",
      "lineOrBox": "Line Or Box"
    }
  },
  "jp": {
    "menu": {
      "value": "値",
      "formula": "公式",
      "insertBlock": "ブロックを挿入",
      "deleteBlock": "ブロックを削除",
      "insertRow": "行を挿入",
      "deleteRow": "行を削除",
      "modifyType": "ブロックを編集",
      "moveUp": "上に移動",
      "moveDown": "下に移動",
      "lineOrBox": "線やボックス"
    }
  },
  "es": {
    "menu": {
      "value": "Valor",
      "formula": "Fórmula",
      "insertBlock": "Insertar bloque",
      "deleteBlock": "Eliminar el bloqueo",
      "insertRow": "Insertar fila",
      "deleteRow": "Borrar fila",
      "modifyType": "Modificar el tipo",
      "moveUp": "Subir",
      "moveDown": "Moverse hacia abajo",
      "lineOrBox": "Línea o caja"
    }
  },
  "pt": {
    "menu": {
      "value": "Valor",
      "formula": "Fórmula",
      "insertBlock": "Inserir Bloco",
      "deleteBlock": "Eliminar Bloco",
      "insertRow": "Inserir Linha",
      "deleteRow": "Eliminar Linha",
      "modifyType": "Modificar Tipo",
      "moveUp": "Mover para Cima",
      "moveDown": "Mover para Baixo",
      "lineOrBox": "Linha ou Caixa"
    }
  },
  "it": {
    "menu": {
      "value": "Valore",
      "formula": "Formula",
      "insertBlock": "Inserisci Blocco",
      "deleteBlock": "Elimina Blocco",
      "insertRow": "Inserisci Riga",
      "deleteRow": "Elimina Riga",
      "modifyType": "Modifica Tipo",
      "moveUp": "Sposta Su",
      "moveDown": "Sposta Giù",
      "lineOrBox": "Linea o Casella"
    }
  },
  "tw": {
    "menu": {
      "value": "值",
      "formula": "公式",
      "insertBlock": "插入塊",
      "deleteBlock": "刪除塊",
      "insertRow": "插入行",
      "deleteRow": "刪除行",
      "modifyType": "修改塊",
      "moveUp": "上移",
      "moveDown": "下移",
      "lineOrBox": "線或框"
    }
  }
}
</i18n>
